<template>
  <div>
    <!-- Profile -->
    <v-card class="user-detail">
      <v-card-text>
        <div class="profile-header">
          <div
            id="profileName"
            class="profile-title"
          >
            {{ item?.name }}
          </div>
          <div class="profile-details">
            <div class="profile-detail-item">
              <span>User ID:</span>
              <strong id="profileUserId">{{ item?.id }}</strong>
            </div>
            <div class="profile-detail-item">
              <span>Phone:</span>
              <strong id="profilePhone">{{ item?.phone }}</strong>
            </div>
            <div class="profile-detail-item">
              <span>Account Status:</span>
              <strong>
                {{ profile?.is_active ? "Active" : "Inactive" }}
              </strong>
            </div>
            <div class="profile-detail-item">
              <span>Regisration No:</span>
              <strong id="profileVehicle">{{ item?.vehicle_reg_no }}</strong>
            </div>
            <div class="profile-detail-item">
              <span>Vehicle:</span>
              <strong id="profileVehicle">{{ item?.vehicle }}</strong>
            </div>
            <div class="profile-detail-item">
              <span>Joined:</span>
              <strong id="profileJoined">
                {{ item?.joined_at | formatDate("DD-MMM-YYYY") }}
              </strong>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- summary Card -->
    <div class="summary-grid">
      <v-card class="summary-card">
        <div class="summary-card-title">
          Lifetime Stats
        </div>
        <div class="summary-item">
          <span>Total Sessions</span>
          <span
            id="lifetimeSessions"
            class="summary-item-value"
          >
            {{ lifeTimeStats?.total_sessions }}
          </span>
        </div>
        <div class="summary-item">
          <span>Total Hours</span>
          <span
            id="lifetimeHours"
            class="summary-item-value"
          >
            {{ lifeTimeStats?.total_hours }}h
          </span>
        </div>
        <div class="summary-item">
          <span>Total kWh</span>
          <span
            id="lifetimekWh"
            class="summary-item-value"
          >
            {{ lifeTimeStats?.total_energy_consumed }}kWh
          </span>
        </div>
        <div class="summary-item">
          <span>Total Spend</span>
          <span
            id="lifetimeSpend"
            class="summary-item-value"
          >
            {{ lifeTimeStats?.total_spend | commaFormat }}
          </span>
        </div>
        <div class="summary-item">
          <span>Avg/Session</span>
          <span
            id="lifetimeAvg"
            class="summary-item-value"
          >
            {{ lifeTimeStats?.avg_cost_per_session | commaFormat }}
          </span>
        </div>
      </v-card>

      <v-card class="summary-card">
        <div class="summary-card-title">
          This Period
        </div>
        <div class="summary-item">
          <span>Sessions</span>
          <span
            id="periodSessions"
            class="summary-item-value"
          >
            {{ period?.sessions }}
          </span>
        </div>
        <div class="summary-item">
          <span>Cost</span>
          <span
            id="periodCost"
            class="summary-item-value"
          >
            {{ period?.spend | commaFormat }}
          </span>
        </div>
        <div class="summary-item">
          <span>Avg Duration</span>
          <span
            id="periodDuration"
            class="summary-item-value"
          >
            {{ period?.avg_duration_minutes }}min
          </span>
        </div>
        <div class="summary-item">
          <span>Last Session</span>
          <span
            id="periodLastSession"
            class="summary-item-value"
          >
            {{ period?.last_session_at | formatDate("DD-MMM-YYYY") }}
          </span>
        </div>
        <div class="summary-item">
          <span>Preferred Time</span>
          <span
            id="periodTime"
            class="summary-item-value"
          >2-4 PM</span>
        </div>
      </v-card>

      <v-card class="summary-card">
        <div class="summary-card-title">
          Engagement
        </div>
        <div class="summary-item">
          <span>Segment</span>
          <span
            id="segmentBadge"
            class="summary-item-value"
          >
            {{ engagement?.segment }}
          </span>
        </div>
        <div class="summary-item">
          <span>Loyalty Points</span>
          <span
            id="loyaltyPoints"
            class="summary-item-value"
          >
            {{ engagement?.loyalty_points || 0 }}
          </span>
        </div>
        <div class="summary-item">
          <span>Referrals</span>
          <span
            id="referrals"
            class="summary-item-value"
          >
            {{ engagement?.referrals || "-" }}
          </span>
        </div>
        <div class="summary-item">
          <span>Reviews Posted</span>
          <span
            id="reviews"
            class="summary-item-value"
          >
            {{ engagement?.reviews_posted || "-" }}
          </span>
        </div>
        <div class="summary-item">
          <span>Platform</span>
          <span
            id="platform"
            class="summary-item-value"
          >
            {{ engagement?.platform || "-" }}
          </span>
        </div>
      </v-card>
    </div>
    <!-- Summary Card -->
    <!-- Graph Card -->
    <section class="charts-section">
      <v-card :loading="loading">
        <v-card-title>
          <div class="title">
            Spending Trend (Monthly)
          </div>
        </v-card-title>
        <v-card-text>
          <apexchart
            type="area"
            height="300"
            :options="spending_trend.chartOptions"
            :series="spending_trend.series"
          />
        </v-card-text>
      </v-card>
      <v-card :loading="loading">
        <v-card-title>
          <div class="title">
            Payment Method Breakdown
          </div>
        </v-card-title>
        <v-card-text>
          <apexchart
            type="donut"
            height="300"
            :options="paymentBreakDown?.chartOptions"
            :series="paymentBreakDown?.series"
          />
        </v-card-text>
      </v-card>
    </section>
    <!-- Graph Card -->
    <!-- Session History Card -->
    <section class="session-history">
      <v-card>
        <v-card-title>
          <div class="title">
            Session History
          </div>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="_header"
            :items="sessionsList"
            :items-per-page="3"
            hide-default-footer
          >
            <template v-slot:item.id="{ item: t }">
              <div
                class="open-link"
                @click="$emit('onSession', t)"
              >
                {{ t?.id }}
              </div>
            </template>
            <template v-slot:item.started_at="{ item: t }">
              <div>
                {{ t?.started_at | formatDate }}
              </div>
            </template>
            <template v-slot:item.duration_minutes="{ item: t }">
              <div>{{ t?.duration_minutes }} min</div>
            </template>
            <template v-slot:item.energy_consumed="{ item: t }">
              <div>{{ t?.energy_consumed }} kWh</div>
            </template>
            <template v-slot:item.total_cost="{ item: t }">
              <div>{{ t?.total_cost | commaFormat }}</div>
            </template>
            <template v-slot:item.payment_type="{ item: t }">
              <div>{{ t?.payment_type || "-" }}</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </section>
    <!-- Session History Card -->
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import { mapGetters } from "vuex/dist/vuex.common.js";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      //
      list: null,
      sessionsList: [],
      sessionlist: [
        {
          sessionId: "SES_001",
          dateTime: "Apr 28, 2:30 PM",
          station: "Lahore M2-KM54",
          duration: "45 min",
          kwh: "22 kWh",
          cost: "PKR 220",
          payment: "Card",
        },
        {
          sessionId: "SES_002",
          dateTime: "Apr 27, 5:00 PM",
          station: "Islamabad CBD",
          duration: "45 min",
          kwh: "18 kWh",
          cost: "PKR 180",
          payment: "Card",
        },
        {
          sessionId: "SES_003",
          dateTime: "Apr 26, 9:15 AM",
          station: "Karachi Port",
          duration: "75 min",
          kwh: "35 kWh",
          cost: "PKR 350",
          payment: "In-App",
        },
        {
          sessionId: "SES_004",
          dateTime: "Apr 25, 11:45 AM",
          station: "Hyderabad Bypass",
          duration: "60 min",
          kwh: "28 kWh",
          cost: "PKR 280",
          payment: "Cash",
        },
        {
          sessionId: "SES_005",
          dateTime: "Apr 24, 7:20 PM",
          station: "Faisalabad GT Road",
          duration: "90 min",
          kwh: "42 kWh",
          cost: "PKR 420",
          payment: "Card",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      loading: "usersAnalyticsDashboard/getLoading",
    }),
    profile() {
      return this.list?.profile || {};
    },
    lifeTimeStats() {
      return this.list?.lifetime_stats || {};
    },
    period() {
      return this.list?.period_stats || {};
    },
    engagement() {
      return this.list?.engagement || {};
    },
    //
    // ---- Spending Trend ----
    spending_trend() {
      const trend = this.list?.spending_trend || [];

      const series = [
        {
          name: "Sessions",
          data: trend.map((item) => item.sessions),
        },
      ];

      const chartOptions = {
        chart: {
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },

        stroke: {
          curve: "smooth",
          width: 3,
        },

        colors: ["#35A79D"],

        xaxis: {
          categories: trend.map((item) => item.month),
          // labels: {
          //   formatter(val) {
          //     if (!val) return val;
          //     const d = new Date(val);
          //     return d.toLocaleDateString("en-US", {
          //       month: "short",
          //       day: "numeric",
          //     });
          //   },
          // },
        },

        dataLabels: {
          enabled: false,
        },

        grid: {
          show: false,
          // borderColor: "#444",
        },

        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.05,
          },
        },
        markers: {
          size: 4,
          strokeWidth: 2,
          colors: ["#35A79D"],
          strokeColors: "#35A79D",
          hover: {
            size: 6,
          },
        },

        tooltip: {
          theme: "dark",
          y: {
            formatter(val) {
              return `${val} sessions`;
            },
          },
        },
      };

      return { series, chartOptions };
    },

    //  ----- Payment Breakdown -----
    paymentBreakDown() {
      const labels = [];
      const values = [];
      this.item?.payment_mix &&
        Object.entries(this.item.payment_mix).forEach(([key, value]) => {
          labels.push(key);
          values.push(value);
        });
      this;
      const series = values;
      const chartOptions = {
        chart: {
          type: "donut",
          background: "transparent",
          toolbar: {
            show: false,
          },
        },

        title: {
          text: "Payment Method Breakdown (Card vs Cash)",
          align: "left",
          style: {
            color: "#fff",
            fontSize: "22px",
            fontWeight: 600,
          },
        },

        labels: labels,

        colors: ["#5DADE2", "#FF5C5C"],

        legend: {
          show: true,
          position: "top",
          horizontalAlign: "center",

          labels: {
            colors: "#cfcfcf",
          },

          markers: {
            width: 14,
            height: 14,
            radius: 2,
          },
        },

        plotOptions: {
          pie: {
            donut: {
              size: "48%", // hole size
            },
          },
        },

        stroke: {
          show: true,
          width: 3,
          colors: ["#fff"],
        },

        dataLabels: {
          enabled: false,
        },

        tooltip: {
          theme: "dark",
          y: {
            formatter(val) {
              return `${val}%`;
            },
          },
        },
      };
      return { series, chartOptions };
    },
    //
    _header() {
      const head = [
        {
          text: "Session ID",
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: "Date/Time",
          align: "left",
          sortable: true,
          value: "started_at",
        },
        {
          text: "Station",
          align: "left",
          sortable: true,
          value: "location_name",
        },
        {
          text: "Duration",
          align: "left",
          sortable: true,
          value: "duration_minutes",
        },
        {
          text: "kWh",
          align: "left",
          sortable: true,
          value: "energy_consumed",
        },
        {
          text: "Cost",
          align: "left",
          sortable: true,
          value: "total_cost",
        },
        {
          text: "Payment",
          align: "left",
          sortable: true,
          value: "payment_type",
        },
      ];

      return head;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const params = {
        id: this.item?.id,
      };
      await this.$store
        .dispatch("usersAnalyticsDashboard/profile", params)
        .then((res) => {
          this.list = res;
        });
      await this.$store
        .dispatch("usersAnalyticsDashboard/sessions", params)
        .then((res) => {
          this.sessionsList = res;
        });
    },
  },
};
</script>
<style lang="sass" scoped>
.profile-header
    padding: 25px
    border-radius: 8px
    // margin-bottom: 25px

.profile-title
    font-size: 28px
    font-weight: bold
    color: $theme-color
    margin-bottom: 10px
.profile-details
    display: grid
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr))
    gap: 15px
    color: gray
    font-size: 12px
.profile-detail-item
    display: flex
    justify-content: space-between

.summary-grid
    display: grid
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr))
    gap: 1rem
    margin: 1rem 0

.summary-card
    padding: 20px
    border-radius: 0 !important

.summary-card-title
    font-size: 14px
    font-weight: bold
    color: $theme-color
    margin-bottom: 15px
    text-transform: uppercase

.summary-item
    display: flex
    justify-content: space-between
    margin-bottom: 10px
    padding-bottom: 10px
    border-bottom: 1px solid gray
    color: gray
    font-size: 12px

.summary-item-value
    color: $theme-color
    font-weight: bold

.v-card__title
    padding-top: 1rem !important
    text-align: left !important
    .title
        font-size: 14px
        font-weight: bold
        padding-bottom: 0.5rem


.charts-section
  display: flex
  gap: 1rem
  padding-bottom: 1rem
  div
    flex: 0 0 calc(50% - 8px)
    // max-width: calc(50% - 8px)
    box-sizing: border-box


@media only screen and (max-width: 960px)
    .charts-section
      flex-wrap: wrap
      gap: 1rem
      div
        flex: 0 0 100%
        max-width: 100%
</style>
